import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { useState } from 'react';
import { ILegalRequirementFullObject } from '../../../Interfaces/ILegalRequirement';
import { ILegalPhaseFullObject } from '../../../Interfaces/ILegalPhase';
import { ICourtCourtRole } from '../../../Interfaces/IAemter';
import { getEmptyReq } from '../../../core/generic_helper';
import { EditLegalRequirementData } from './EditLegalRequirementData';

interface IProps {
  isOpenEditLegalRequirement: boolean;
  setIsOpenEditLegalRequirement: Function;
  updateLegalRequirementArray: Function;
  currentPhase: ILegalPhaseFullObject;
  courtcourtroleArray: ICourtCourtRole[];
  legaltransactionId: number;
  legalRequirement?: ILegalRequirementFullObject;
}

export const EditLegalRequirement: React.FC<IProps> = ({
  isOpenEditLegalRequirement,
  setIsOpenEditLegalRequirement,
  updateLegalRequirementArray,
  currentPhase,
  courtcourtroleArray,
  legaltransactionId,
  legalRequirement,
}) => {
  const [editLegalRequiremnt, setEditLegalRequirement] =
    useState<ILegalRequirementFullObject>(
      legalRequirement ? legalRequirement : getEmptyReq(currentPhase)
    );

  const handleEditReq = () => {
    if (legalRequirement) {
      updateLegalRequirementArray([
        ...currentPhase.LegalRequirementArray.map(x =>
          x.idLegalRequirement === editLegalRequiremnt.idLegalRequirement
            ? editLegalRequiremnt
            : x
        ),
      ]);
    } else {
      updateLegalRequirementArray([
        ...currentPhase.LegalRequirementArray,
        editLegalRequiremnt,
      ]);
    }

    setIsOpenEditLegalRequirement(false);
  };

  return (
    <>
      <Dialog
        open={isOpenEditLegalRequirement}
        onClose={() => setIsOpenEditLegalRequirement(false)}
        maxWidth='lg'
        fullWidth
      >
        <DialogTitle
          variant='h5'
          sx={{
            borderBottom: '1px solid #ccc',
          }}
        >
          {legalRequirement ? 'Maßnahme bearbeiten' : 'Maßnahme hinzufügen'}
        </DialogTitle>
        <DialogContent>
          <EditLegalRequirementData
            currentRequirement={editLegalRequiremnt}
            setCurrentRequirement={setEditLegalRequirement}
            courtcourtroleArray={courtcourtroleArray}
            legaltransactionId={legaltransactionId}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant='outlined'
            onClick={() => setIsOpenEditLegalRequirement(false)}
          >
            Abbruch
          </Button>
          <Button
            variant='contained'
            onClick={handleEditReq}
            disabled={editLegalRequiremnt.LegalRequirement === ''}
          >
            Übernehmen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
